import { ReactComponent as GitHub } from 'styles/icon/github.svg';
import { ReactComponent as Linkedin } from 'styles/icon/linkedin.svg';
import { ReactComponent as Discord } from 'styles/icon/discord.svg';
import footer from './Footer.module.scss';

function SocialLinks() {
  return (
    <div className={footer.footer__list_icons} id="social_links">
      <a href="https://github.com/staqio" target="_blank" rel="noopener noreferrer"><GitHub /></a>
      <a href="https://www.linkedin.com/company/staqio/about/" target="_blank" rel="noopener noreferrer"><Linkedin /></a>
      <a href="https://discord.com/channels/1123943804223885332/1123943804223885335" target="_blank" rel="noopener noreferrer"><Discord /></a>
    </div>
  );
}

export default SocialLinks;